export default {
  'profile.verified': 'Verified',
  'profile.unverified': 'Unverified',
  'profile.refresh': 'Refresh',
  'profile.name': 'Name',
  'profile.getCode': 'Get Code',
  'profile.codeTip': 'Enter code',
  'profile.verifyCode': 'Verification Code',
  'profile.phoneChange': 'Change Phone Number',
  'profile.checkPhone': 'Verify Current Phone',
  'profile.bindNewPhone': 'Bind New Phone',
  'profile.nuxt': 'Next',
  'profile.changeSuccess': 'Successfully changed!',
  'profile.firstNameTip': 'Enter First Name',
  'profile.lastNameTip': 'Enter Last Name',
  'profile.emailChange': 'Change Email',
  'profile.checkEmail': 'Verify Current Email',
  'profile.bindNewEmail': 'Bind New Email',
  'profile.bindEmailTip': 'Enter New Email',
  'app.profile': 'Personal Center',
  'app.profile.account': 'Account Information',
  'app.profile.account.save': 'Save',
  'app.profile.account.account': 'Account',
  'app.profile.account.password': 'Password',
  'app.profile.account.password.update': 'Last password update on',
  'app.profile.account.password.reset': 'Reset Password',
  'app.profile.account.name.first': 'First Name',
  'app.profile.account.name.last': 'Last Name',
  'app.profile.account.name.phone': 'Mobile Phone',
  'app.profile.account.name.phone.tip':
    'We may use this phone number to send you messages about security events, bills and business alerts',
  'app.profile.account.name.url': 'Callback address',
  'app.profile.account.name.urlTip':
    'Must start with http:// or https://, custom ports are not supported, and private network segments with IP addresses of 10.0.0.0/8, 172.16.0.0/12, and 192.168.0.0/16 are not supported.',
  'app.profile.account.name.verification': 'Verification',
  'app.profile.account.name.verification.tip[1]': 'Passed',
  'app.profile.account.name.verification.tip[2]': 'Failed',
  'app.profile.developer': 'Developer Information',
  'app.profile.developer.remark': 'Limited to API calls',
  'app.profile.developer.label[1]': 'Developer ID (DevKey)',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': 'View and copy',
  'app.profile.developer.reset': 'Reset',
  'app.profile.developer.reset.tip': 'Tip', //new added
  'app.profile.developer.reset.tip.content':
    'Dev Secret changes will affect the API push, requiring the caller to change the calling code', //new added
  'app.profile.developer.reset.tip.sure': 'Confirm', //new added
  'app.profile.developer.reset.tip.cancel': 'Later ', //new added
  'app.profile.developer.copy.success': 'Copy successful',
  'app.profile.developer.reset.success': 'Reset successful',
  'app.profile.single': 'Single Sign-on',
  'app.profile.single.tip[1]': 'Improve security and reduce the risk of account',
  'app.profile.single.tip[2]':
    'Avoid frequent account creation when employees use different business systems',
  'app.profile.single.tip[3]':
    'Simplify authentication by using an internal employee account system',
  'app.profile.single.enable': 'Contact Us',
  'app.profile.single.title': 'Business Request',
  'app.profile.single.subject': 'Subject',
  'app.profile.single.subject.value': 'Enable Single Sign-on for my account',
  'app.profile.single.content':
    'Hi,I would like to enable Single Sign On.Please reach out to me.Thanks.',
  'app.profile.single.subject.validator': 'Please input your subject',
  'app.profile.single.subject.doc': 'Enable Single Sign-on for my account',
  'app.profile.single.message': 'Message',
  'app.profile.single.message.validator': 'Please input your message',
  'app.profile.single.submit': 'Submit',
  'app.profile.single.submit.success': `Submitted successfully, waiting for the administrator's email reply`,
  'app.profile.account.deletion': 'Account Deletion',
  'app.profile.account.deletion.warn':
    'When you delete your account, your account with your user information, business information, order information and other data associated will be permanently deleted. Once your account is deleted, you will not be able to recover your account or data.',
  'app.profile.account.deletion.action': 'Delete My Account',
  'app.profile.delete.title': 'Delete account',
  'app.profile.delete.content':
    'Warning! Deleting your account is irreversible. It will permanently delete data and information such as users, businesses, balances, bills, orders and interests of this account, and all related services will be terminated.',
  'app.profile.delete.content2':
    'Perhaps you can accomplish your objective by "modifying the account email address" or "granting role permissions to organization members." It is recommended to try to keep using the account unless absolutely necessary.',
  'app.profile.delete.warn':
    'When there is supplementary to be paid, your account cannot be deleted!',
  'app.profile.delete.cancel': 'Cancel',
  'app.profile.delete.next': 'Next',
  'app.profile.delete.delete': 'Delete',
  'app.profile.delete.confirm': 'Confirm the deletion',
  'app.profile.delete.confirm.content':
    'Before your account deletion takes effect, we will verify your account as follows . Please find the verification code in the email.',
  'app.profile.delete.confirm.send': 'Send verification code',
  'app.profile.delete.confirm.send.resend': 'Resend verification code',
  'app.profile.delete.confirm.resend': 'Resend',
  'app.profile.delete.confirm.rule': 'Please enter the correct verification',
  'app.profile.delete.confirm.code.title': 'Email Verification Code',
  'app.profile.delete.confirm.code.desc':
    'To verify your identity and ensure account security, please provide the verification code received in your email currentAccount.email',
  'app.profile.delete.confirm.reason.title': 'Reason for Deletion',
  'app.profile.delete.confirm.reason.desc': 'This information helps us improve our product',
  'app.profile.delete.confirm.reason.placeholder': 'Select a reason',
  'app.profile.delete.confirm.reason.select1': 'Deleting a test account',
  'app.profile.delete.confirm.reason.select2': 'Switching to another account',
  'app.profile.delete.confirm.reason.select3': 'No longer interested in using EngageLab services',
  'app.profile.delete.confirm.reason.select4': 'Other',
  'app.profile.reset.title': 'Reset Password',
  'app.profile.reset.password.old': 'Old Password',
  'app.profile.reset.password.old.placeholder': 'Please enter old password',
  'app.profile.reset.password.new': 'New Password',
  'app.profile.reset.password.new.placeholder': 'Please enter a new password',
  'app.profile.reset.password.confirm': 'Confirm Password',
  'app.profile.reset.password.confirm.placeholder': 'Please confirm your password',
  'app.profile.reset.cancel': 'Cancel',
  'app.profile.reset.confirm': 'Confirm',
  'app.profile.rule.blank': 'This field cannot be blank',
  'app.profile.reset.new.rule[0]': 'Contains at least 8 characters',
  'app.profile.reset.new.rule[1]': 'Should contain uppercase and lowercase letter at the same time',
  'app.profile.reset.new.rule[2]': 'Contains at least one number (0-9) or one symbol',
  'app.profile.reset.confrim.rule[0]': 'Passwords do not match',
  'app.profile.reset.old.rule[0]': 'Inconsistent passwords',
  'app.profile.reset.success': 'Your password has been reset',
  'app.profile.aws.title': 'Amazon Orders',
  'app.profile.aws.subtitle':
    'Your EngageLab account is linked to your Amazon account. Link your Amazon orders to EngageLab services here to enjoy VIP benefits.',
  'app.profile.aws.account': 'Amazon Account Number:',
  'app.profile.aws.btn': 'Manage',
  'app.profile.human.code.loadingTip': 'Please wait...',
  'app.profile.human.code.placeholder': 'Please enter the verification code',
  'app.profile.human.check.tip': 'Please complete the human verification first.',
  'app.profile.human.check.error': 'Human verification failed, please try again.',
  'app.profile.sso.title': 'SSO Configuration Service',
  // SSO Empty
  'app.profile.sso.empty.title': 'You have not configured any SSO',
  'app.profile.sso.empty.description':
    'After configuring SSO, users, members, and business partners under the configured organization can securely access everything they need to do their best work, as well as an intuitive login experience.',
  'app.profile.sso.empty.configure': 'Configure SSO',
  'app.profile.sso.empty.title2': 'No SSO Benefits',
  'app.profile.sso.empty.description2':
    'Your organization has not yet enabled the SSO benefits. Please contact the sales to activate SSO before configuring.',
  'app.profile.sso.empty.contact': 'Contact Us',
  'app.profile.sso.empty.contact.content': 'I want to create SSO',
  // SSO List
  'app.profile.sso.list.configure': 'Configure SSO',
  'app.profile.sso.list.authorizedOrg': 'Authorized Organization',
  'app.profile.sso.list.benefitStatus': 'Benefit Status',
  'app.profile.sso.list.authorizedOrgLong':
    'Authorized Organization Authorized Organization Authorized Organization Authorized Organization Authorized Organization Authorized Organization Authorized Organization',
  'app.profile.sso.list.edit': 'Edit',
  'app.profile.sso.list.authorize': 'Authorize',
  'app.profile.sso.list.delete': 'Delete',
  'app.profile.sso.list.deleteConfirm.title': 'Confirm delete SSO service {name}?',
  'app.profile.sso.list.deleteConfirm.content':
    'After deleting the SSO service, organizations authorized by this service will no longer support SSO login, the login link will be invalid, and they will receive an email to stop using SSO login.',
  'app.profile.sso.list.deleteSuccess': 'Delete successfully',
  'app.profile.sso.list.confirm.modify.title': 'Confirm modify SSO service authorization?',
  'app.profile.sso.list.confirm.modify.content.add':
    'Newly authorized organizations will receive an email reminder that includes the SSO login link for them to log in.',
  'app.profile.sso.list.confirm.modify.content.remove':
    'Canceled authorized organizations will receive an email reminder that includes the alternative login links for them to log in.',
  // SSO Option
  'app.profile.sso.option.step1': 'IdP Configuration',
  'app.profile.sso.option.step2': 'Data Source Return',
  'app.profile.sso.option.step3': 'Authorize Organization',
  'app.profile.sso.option.step4': 'Verification',
  'app.profile.sso.option.continue': 'Continue',
  'app.profile.sso.option.prev': 'Prev',
  'app.profile.sso.option.back': 'Back',
  'app.profile.sso.option.submit': 'Submit',
  'app.profile.sso.option.save': 'Save and Verify',
  // SSO Step 1
  'app.profile.sso.step1.title': 'Configure Engagelab in IdP',
  'app.profile.sso.step1.description':
    "Single Sign-On (SSO), you first need to add Engagelab as an application in your Identity Provider (IdP). Please contact your organization's IdP administrator to add the application configuration under your account.",
  'app.profile.sso.step1.serviceType': 'SSO Service Type',
  'app.profile.sso.step1.guideText':
    "You can use the following token to collaborate with your organization's IdP administrator:",
  'app.profile.sso.step1.copy': 'Copy',
  'app.profile.sso.step1.confirmTip':
    'I confirm that the Engagelab application information has been updated in your IdP',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  // SSO Step 2
  'app.profile.sso.step2.title': 'Enter IdP Return Data',
  'app.profile.sso.step2.description':
    'Now that you have set up the Engagelab application in your Identity Provider and have the necessary information, please enter the following information from the IdP application here.',
  'app.profile.sso.step2.serviceName': 'SSO Service Name',
  'app.profile.sso.step2.serviceNamePlaceholder':
    'Please enter a name that describes the SSO service for easy distinction in the service list',
  'app.profile.sso.step2.certificate': 'x509 Certificate',
  'app.profile.sso.step2.certificatePlaceholder': 'Please copy the base64 certificate content here',
  'app.profile.sso.step2.loginUrl': 'IdP Login URL',
  'app.profile.sso.step2.loginUrlPlaceholder': 'Please enter the Identity Provider login URL',
  'app.profile.sso.step2.logoutUrl': 'IdP Logout URL',
  'app.profile.sso.step2.logoutUrlPlaceholder': 'Please enter the Identity Provider logout URL',
  // SSO Step 3
  'app.profile.sso.step3.title': 'Authorize IdP to Organization',
  'app.profile.sso.step3.description':
    'Please authorize this SSO service to the organizations you have created. Organization members can log in to Engagelab using the configured Identity Provider (IdP).',
  'app.profile.sso.step3.selectOrg': 'Select Organization',
  'app.profile.sso.step3.contactBusiness': 'Contact Business',
  'app.profile.sso.step3.noBenefitTip': 'Current organization has no rights and is not available',
  'app.profile.sso.step3.saveConfirm.title':
    'After configuring SSO service for the organization, organization members must use SSO login to access the organization',
  'app.profile.sso.step3.saveConfirm.content':
    'After saving, all organization members will be logged out and receive an email requiring SSO login',
  'app.profile.sso.step3.canAuthorize': 'Authorizable',
  'app.profile.sso.step3.numLimit.title': 'Restricted',
  'app.profile.sso.step3.numLimit.tip': 'SSO Protocol Limit Exceeded',
  'app.profile.sso.step3.numLimit.text': 'SSO protocol limit exceeded, not available',
  'app.profile.sso.step3.noBenefit.title': 'No Rights',
  'app.profile.sso.step3.noBenefit.text': 'Current organization has no rights, not available',
  'app.profile.sso.step3.column.orgId': 'Organization ID',
  'app.profile.sso.step3.column.orgName': 'Organization Name',
  'app.profile.sso.step3.column.memberNum': 'Member Count',
  'app.profile.sso.step3.column.authStatus': 'Authorization Status',
  'app.profile.sso.step3.column.timeZone': 'Time Zone',
  'app.profile.sso.step3.column.createTime': 'Creation Time',
  // SSO Step 4
  'app.profile.sso.step4.title': 'Verify SSO Service',
  'app.profile.sso.step4.description':
    'Now that you have completed all SSO configurations, please finally confirm that users can successfully log in to Engagelab using SSO.',
  'app.profile.sso.step4.loginUrl': 'SSO Login URL',
  'app.profile.sso.step4.tip': 'Tip',
  'app.profile.sso.step4.tipContent':
    'Accounts logged in through this link will automatically be granted the Default role if they have no role in the organization. You can modify their role after members join.',
  'app.profile.sso.step4.notice': 'Please Note',
  'app.profile.sso.step4.noticeContent':
    'Accounts logged in through this link will automatically be granted the Default role if they have no role in the organization. You can modify their role after members join.',
  'app.profile.sso.step4.needHelp': 'Still need help',
  'app.profile.sso.step4.helpContent':
    'Unable to log in successfully? Please refer to the documentation for inspection.',
  'app.profile.sso.step4.viewDoc': 'View Documentation',
  // SSO Details
  'app.profile.sso.details.title': 'SSO Service Details',
  'app.profile.sso.details.serviceDetails': 'SSO Service Details',
  'app.profile.sso.details.name': 'Name',
  'app.profile.sso.details.namePlaceholder': 'Please enter name',
  'app.profile.sso.details.type': 'Type',
  'app.profile.sso.details.typePlaceholder': 'Please enter type',
  'app.profile.sso.details.loginLink': 'SSO Login Link',
  'app.profile.sso.details.loginLinkPlaceholder': 'Please enter SSO login link',
  'app.profile.sso.details.spConfig': 'SP Configuration Information',
  'app.profile.sso.details.entityIdPlaceholder': 'Please enter Entity ID',
  'app.profile.sso.details.idpConfig': 'IDP Configuration Information',
  'app.profile.sso.details.certificatePlaceholder': 'Please enter X.509 certificate',
  'app.profile.sso.details.loginUrlPlaceholder': 'Please enter Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': 'Please enter Logout URL',
  'app.profile.sso.details.urlPlaceholder': 'Please enter correct URL',
  'app.profile.sso.details.certificateExpiry': 'Certificate will expire on {date}',
  'app.profile.sso.details.cancel': 'Cancel',
  'app.profile.sso.details.save': 'Save',
  'app.profile.sso.details.edit': 'Edit',
  // SSO OrgSelect
  'app.profile.sso.orgSelect.title': 'Authorize Organization',
  'app.profile.sso.orgSelect.availableOrg': 'Available Organizations',
  'app.profile.sso.orgSelect.serviceExpired': 'Service benefits expired, not available',
  'app.profile.sso.orgSelect.contactBusiness': 'Contact Business',
  'app.profile.sso.orgSelect.authorizedService': 'Authorized Service',
  'app.profile.sso.orgSelect.serviceNameLong':
    'SSO service name service name service name service name SSO service name service name service name service name SSO service name service name service name service name SSO service name service name service name service name',
  'app.profile.sso.orgSelect.selectedOrg': 'Selected Organizations',
  'app.profile.sso.orgSelect.noSelectedOrg':
    'No selected organizations, please select from the left',
  'app.profile.sso.orgSelect.noAvailable': 'No available organizations',
  'app.profile.sso.orgSelect.authorized': 'Authorized',
  'app.profile.sso.orgSelect.cancel': 'Cancel',
  'app.profile.sso.orgSelect.save': 'Save',
  'app.profile.sso.orgSelect.canAuthorize': 'Can Authorize',
  'app.profile.sso.orgSelect.otherAuthorize': 'Other Authorization',
  'app.profile.sso.orgSelect.noBenefit': 'No Benefits',
  'app.profile.sso.orgSelect.saveSuccess': 'Save Success',
  'app.profile.sso.list.ssoServiceName': 'SSO Service Name',
  'app.profile.sso.list.ssoType': 'Type',
  'app.profile.sso.list.ssoLoginUrl': 'Login Link',
  'app.profile.sso.list.authOrgList': 'Authorized Organizations',
  'app.profile.sso.authorized.organizations': 'Authorized Organizations',
  'app.profile.sso.benefit.status': 'Benefit Status',
  'app.sso.no.permission.title': 'No Permission',
  'app.sso.no.permission.desc': 'Please contact the administrator for permission',
  'app.sso.no.permission.logout': 'Logout',
};
